<template>
  <div class="topDiv">
    <div class="content item">
      <el-row style="font-size: 16px; color: #f82b18; padding-left: 24px">
        <el-col class="marginTop" :span="2"
          ><span>{{ posMsg.cpPositionName }}</span>
        </el-col>

        <el-col
          :span="4"
          class="buttonStart marginTop"
          v-if="posMsg.cpIsUse == 4"
          ><span>已关闭</span></el-col
        >
        <el-col
          :span="4"
          class="buttonStart marginTop"
          v-else-if="posMsg.cpIsUse == 1"
          ><span>已开启</span></el-col
        >
        <el-col
          :span="4"
          class="buttonStart marginTop"
          v-else-if="posMsg.cpIsUse == 3"
          ><span>审核失败</span></el-col
        >
        <el-col :span="4" class="buttonStart marginTop" v-else
          ><span>未审核</span></el-col
        >
      </el-row>

      <el-row class="company" style="padding-top: -5px">
        <el-col :offset="11" :span="3">
          <span style="color: #f82b18; padding-right: 5px">{{
            posMsg.userSee
          }}</span>
          <span>人查看</span>
        </el-col>
        <el-col :span="3">
          <span style="color: #f82b18; padding-right: 5px">{{
            posMsg.postionChatNumber
          }}</span>
          <span>人沟通过</span>
        </el-col>
        <el-col :span="3"
          ><span
            >{{ posMsg.createTime | getDate("-") }}发布
            <!-- {{posMsg.cpIsUse}} -->
            </span
          ></el-col
        >
        <el-col
          v-if="posMsg.cpIsUse == 3 || posMsg.cpIsUse == 4"
          
          :span="1"
          @click.native="updateContent"
          ><span style="cursor: pointer;">编辑</span></el-col
        >

        <!-- <el-col
          :span="1"
          v-show="posMsg.cpIsUse == 0"
          @click.native="updateStatus(1)"
          ><span>打开</span></el-col
        > -->
        <el-col
          :span="1"
          v-if="posMsg.cpIsUse == 1"
          @click.native="updateStatus(4)"
          ><span style="cursor: pointer;">关闭</span></el-col
        >
      </el-row>

      <el-row class="company" style="padding-top: -10px">
        <el-col :span="12" class="xingzhi">
          <span style="font-size: 16px; color: rgba(242, 20, 47, 1)"
            >{{ !posMsg.cpMinSalary?0:posMsg.cpMinSalary.replace(">", "") }}-{{
              !posMsg.cpMaxSalary?0:posMsg.cpMaxSalary.replace(">", "")
            }}</span
          >
          <span style="margin-left: 30px"
            >经验{{ posMsg.cpJobYearsLabel }}</span
          >
          <span style="vertical-align: top; padding: 0 10px">|</span>
          <span style>{{ posMsg.cpEducationLabel }}</span>
          <span style="vertical-align: top; padding: 0 10px">|</span>
          <span style>{{ posMsg.cpFormsOfEmploymentLabel }}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import PcPersionHelp from "../../views/company/PcPersionHelp.vue";
import { getDate } from "@/utils/date.js";
import { getAction, postAction, putAction } from "@/comm/manage";
export default {
  name: "",
  components: {
    PcPersionHelp,
  },
  props: ["posMsg"],
  data() {
    return {
      menuIndex: 2,
      input: "",
    };
  },
  filters: {
    getDate: function (time, splitor) {
      if (time != null && time != "") {
        var date = new Date(time);
        return getDate(date, splitor);
      } else {
        return "";
      }
    },
  },
  methods: {
    updateStatus(type) {
      this.posMsg.cpIsUse = type;
      putAction("/position/tsCompanyPosition/edit", this.posMsg).then((res) => {
        if (res.success) {
          this.$message.success("信息已修改");
        } else {
          console.log(res);
          this.$message.error("更新异常");
          // this.$message.error(res.message);
          // reject();
        }
      });
    },
    changeClass(index) {
      this.menuIndex = index;
      //加载不同类型残疾人数据
    },
    updateContent() {
      this.$router.push({
        name: "PcPulishPosition",
        params: { positionMsg: this.posMsg },
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.topDiv {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 21px;

  .marginTop {
    margin-top: 20px;
  }

  .buttonStart {
    width: 50px;
    height: 20px;
    background: #f82b18;
    border-radius: 2px;
    color: #FFFFFF;
    font-size: 12px;
    text-align: center;
  }

  .xingzhi {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #c2c2c2;
    line-height: 10px;
    padding-right: 10px;
    padding-left: 24px;
  }

  .marginTop40 {
    margin-top: 35px;
  }

  .fenge {
    margin: 0 10px;
    border-right: 1px solid #dddddd;
    line-height: 5px;
    height: 5px;
  }

  .topBannder {
    width: 1200px;
    margin: 0 auto;
  }

  .content {
    background: rgba(255, 255, 255, 1);
    width: 100%;
    margin: 0 auto;

    .item {
      text-align: left;
      padding-top: 22px;
      margin-bottom: 10px;
    }
  }
}

.item {
  padding: 0 0 28px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}
</style>